export interface TutorialStep {
  id: number;
  title: string;
  message: string;
  highlightId?: string;
  highlightIds?: string[];
  additionalHighlightIds?: string[];
  action?: 'click' | 'any' | 'none' | 'drag' | 'multi-click';
  screen?: string;
  gameMode?: string;
  target?: string;
  dialogPosition?: 'top' | 'bottom';
}

export const TUTORIAL_STEPS: Record<number, TutorialStep> = {
  1: {
    id: 1,
    title: "WELCOME TO NUMQ!",
    message: "NumQ is a fast-paced math game to sharpen your brain. Let's get you ready to play!",
    screen: "home",
    action: "any"
  },
  2: {
    id: 2,
    title: "THE HEART SYSTEM",
    message: "First, look at your Hearts. Playing standard modes costs 1 Heart. They refill automatically every 10 mins!",
    screen: "home",
    action: "any",
    highlightId: "header-hearts",
    dialogPosition: "bottom"
  },
  3: {
    id: 3,
    title: "COINS & HOSHI",
    message: "You'll also see Coins and Hoshi. Use these for Reward Boxes and upgrading your Anima Cores.",
    screen: "home",
    action: "any",
    highlightIds: ["header-coins", "header-gems"],
    dialogPosition: "bottom"
  },
  4: {
    id: 4,
    title: "START PLAYING",
    message: "Now you're ready! Click PLAY to view the game modes.",
    screen: "home",
    action: "click",
    highlightId: "home-play-button"
  },
  5: {
    id: 5,
    title: "CHOOSE YOUR CHALLENGE",
    message: "Welcome to the modes screen! Here you can access our four unique puzzle challenges.",
    screen: "choose-mode",
    action: "any",
    highlightIds: ["mode-shellcrush","mode-goldrush","mode-pemdas","mode-starburst"],
    dialogPosition: "top"
  },
  6: {
    id: 6,
    title: "CHOOSE SHELL CRUSH",
    message: "Select Shell Crush for your first session!",
    screen: "choose-mode",
    action: "click",
    highlightId: "mode-shellcrush"
  },
  7: {
    id: 7,
    title: "SHELL CRUSH",
    message: "Connect shells that add up to 10, 20, 30, and so on.",
    screen: "sumgame",
    action: "any"
  },
  8: {
    id: 8,
    title: "FIRST MATCH",
    message: "Drag across these shells: 3 → 4 → 3 to make 10!",
    screen: "sumgame",
    action: "drag",
    highlightIds: ["shell-tile-0-7","shell-tile-1-7","shell-tile-2-7"]
  },
  9: {
    id: 9,
    title: "NUMBER 9",
    message: "Number 9 shells are special! They clear adjacent shells crosswise.",
    screen: "sumgame",
    action: "any"
  },
  10: {
    id: 10,
    title: "CLEVER PAIR",
    message: "Drag 1 → 9 to quickly make 10!",
    screen: "sumgame",
    action: "drag",
    highlightIds: ["shell-tile-4-4","shell-tile-5-4"]
  },
  11: {
    id: 11,
    title: "FEVER MODE SHELLS",
    message: "In Fever Mode, Number 9 shells explode and clear all 8 surrounding tiles!",
    screen: "sumgame",
    action: "any"
  },
  12: {
    id: 12,
    title: "FEVER MODE MATCH",
    message: "Fever doubles your points! Drag 1 → 9 again.",
    screen: "sumgame",
    action: "drag",
    highlightIds: ["shell-tile-4-4","shell-tile-5-4"]
  },
  13: {
    id: 13,
    title: "TUTORIAL COMPLETED",
    message: "Awesome! Shell Crush complete.\n\nLet's look at the next mode!",
    screen: "sumgame",
    action: "any"
  },
  14: {
    id: 14,
    title: "NEXT CHALLENGE",
    message: "Let's check out Gold Rush mode next.",
    screen: "choose-mode",
    action: "click",
    highlightId: "mode-goldrush"
  },
  15: {
    id: 15,
    title: "INTRO TO GOLD RUSH",
    message: "Connect adjacent gold bars to match the target sum at the top.",
    screen: "goldrush",
    action: "any",
    highlightId: "goldrush-tutorial-1"
  },
  16: {
    id: 16,
    title: "INCREMENTING TARGET",
    message: "Each successful match increases the target by 1!",
    screen: "goldrush",
    action: "any",
    highlightId: "goldrush-tutorial-1"
  },
  17: {
    id: 17,
    title: "GOLD RUSH (TARGET 10)",
    message: "",
    screen: "goldrush",
    action: "drag",
    highlightIds: ["goldrush-tile-2-2","goldrush-tile-2-3"],
    additionalHighlightIds: ["goldrush-tutorial-1"]
  },
  18: {
    id: 18,
    title: "GOLD RUSH (TARGET 11)",
    message: "",
    screen: "goldrush",
    action: "drag",
    highlightIds: ["goldrush-tile-3-2","goldrush-tile-3-3"],
    additionalHighlightIds: ["goldrush-tutorial-1"]
  },
  19: {
    id: 19,
    title: "GOLD RUSH (TARGET 12)",
    message: "",
    screen: "goldrush",
    action: "drag",
    highlightIds: ["goldrush-tile-1-2","goldrush-tile-1-3"],
    additionalHighlightIds: ["goldrush-tutorial-1"]
  },
  20: {
    id: 20,
    title: "GOLD FEVER",
    message: "Fever mode is active! Match the target sum for a massive 3x points multiplier!",
    screen: "goldrush",
    action: "drag",
    additionalHighlightIds: ["goldrush-tutorial-1"],
    dialogPosition: "top"
  },
  21: {
    id: 21,
    title: "GOLD RUSH COMPLETED",
    message: "Great job! You've mastered the Gold Rush tutorial.",
    screen: "goldrush",
    action: "any"
  },
  22: {
    id: 22,
    title: "CLOUD MACH",
    message: "Next up: Cloud Mach. Tap to enter!",
    screen: "choose-mode",
    action: "click",
    highlightId: "mode-pemdas",
    dialogPosition: "top"
  },
  23: {
    id: 23,
    title: "CLOUD MACH INTRO",
    message: "Quick! Choose the side with the larger number.",
    screen: "game",
    action: "any"
  },
  24: {
    id: 24,
    title: "EQUATIONS",
    message: "Heads up: +, -, and × symbols will start appearing as you progress!",
    screen: "game",
    action: "any"
  },
  25: {
    id: 25,
    title: "QUICK THINKING",
    message: "Pick the bigger number. Get 10 correct to proceed!",
    screen: "game",
    action: "none",
    highlightIds: ["tutorial-question-card","tutorial-left-btn","tutorial-right-btn"]
  },
  26: {
    id: 26,
    title: "CLOUD FEVER",
    message: "Fever active! Score 10 correct answers to trigger it.",
    screen: "game",
    action: "any"
  },
  27: {
    id: 27,
    title: "CLOUD FEVER",
    message: "Answer just 2 more questions to finish!",
    screen: "game",
    action: "none"
  },
  28: {
    id: 28,
    title: "CLOUD MACH COMPLETED",
    message: "Excellent! Cloud Mach tutorial is complete.",
    screen: "game",
    action: "any"
  },
  29: {
    id: 29,
    title: "STAR BURST",
    message: "Finally, Star Burst!\n\nThis mode awards massive EXP and Hoshi.",
    screen: "choose-mode",
    action: "click",
    highlightId: "mode-starburst",
    dialogPosition: "top"
  },
  30: {
    id: 30,
    title: "STAR BURST",
    message: "Requires a Star Ticket.\n\nFind them in Reward Boxes, daily logins, or trade 20 Heart Tickets for 1 in the Shop.",
    screen: "choose-mode",
    action: "any",
    highlightId: "starburst-play-btn",
    dialogPosition: "top"
  },
  31: {
    id: 31,
    title: "PRACTICE MODE",
    message: "Play Practice Mode free (5x/day).\n\nIf you score well, spend a Star Ticket post-game to save your score and claim rewards!",
    screen: "choose-mode",
    action: "any",
    highlightId: "starburst-practice-btn",
    dialogPosition: "top"
  },
  32: {
    id: 32,
    title: "FREE STAR TICKET",
    message: "Here's a free Star Ticket on me.\n\nLet's use it now!",
    screen: "choose-mode",
    action: "any",
    highlightId: "starburst-play-btn",
    dialogPosition: "top"
  },
  33: {
    id: 33,
    title: "PLAY STAR BURST",
    message: "Tap PLAY to use your Star Ticket and begin!",
    screen: "choose-mode",
    action: "click",
    highlightId: "starburst-play-btn",
    dialogPosition: "top"
  },
  34: {
    id: 34,
    title: "STAR CHALLENGE",
    message: "Draw boxes over adjacent stars to make sums of 10, 20, or 30 (giving 1, 2, or 3 points respectively). Clear all 3 highlighted combos to win!",
    screen: "applegame",
    action: "none"
  },
  35: {
    id: 35,
    title: "STAR BURST COMPLETED",
    message: "Fantastic! You've wrapped up the Star Burst tutorial.",
    screen: "applegame",
    action: "any"
  },
  36: {
    id: 36,
    title: "CHOOSE NICKNAME",
    message: "Please enter your username to continue your journey!",
    screen: "home",
    action: "none"
  },
  37: {
    id: 37,
    title: "GREAT JOB!",
    message: "Great job! Now let's learn about Anima Cores.\n\nTap Anima on your dashboard to enter the Altar.",
    screen: "home",
    action: "click",
    highlightId: "home-anima-button"
  },
  38: {
    id: 38,
    title: "ALTAR OF ANIMA",
    message: "Welcome to the Altar!\n\nAnima Cores boost your gameplay scores with powerful stat multipliers. Let's look at how they work.",
    screen: "prism",
    action: "any",
    dialogPosition: "bottom"
  },
  39: {
    id: 39,
    title: "ANIMA TIERS (STARS)",
    message: "Cores are ranked by Star Tier (1★ to 3★).\n\nHigher tier Cores unlock more Potential slots (1 slot per Star) to stack multiple boosts!",
    screen: "prism",
    action: "any",
    dialogPosition: "bottom"
  },
  40: {
    id: 40,
    title: "ANIMA TRAITS (COLORS)",
    message: "A Core's color determines its primary Trait (Red, Yellow, Green, Blue, Violet).\n\nTraits give static multipliers like EXP multipliers or Fever point boosts!",
    screen: "prism",
    action: "any",
    dialogPosition: "bottom"
  },
  41: {
    id: 41,
    title: "CORE POTENTIALS",
    message: "Potentials are random sub-stats unlocked on each Star tier.\n\nThey grant extra utility boosts like hybrid game score bonuses or extra time limits!",
    screen: "prism",
    action: "any",
    dialogPosition: "bottom"
  },
  42: {
    id: 42,
    title: "ANIMA FUSION",
    message: "Fuse 3 identical Cores of the same rank and color to evolve them to the next tier!\n\nEvolution upgrades the primary Trait and opens a new random Potential slot.",
    screen: "prism",
    action: "any",
    highlightId: "altar-tab-evolve",
    dialogPosition: "bottom"
  },
  43: {
    id: 43,
    title: "REROLLING STATS",
    message: "Want different Potentials? Reroll the stats on a 3-Star Core using 3-Star fodder Cores!\n\nSame-color fodder consumes 1 Core; different color fodder consumes 2.",
    screen: "prism",
    action: "any",
    highlightId: "altar-tab-reroll",
    dialogPosition: "bottom"
  },
  44: {
    id: 44,
    title: "READY TO GRADUATE",
    message: "That covers the basics of Anima! You can acquire Cores by using tickets at the Shop.\n\nLet's get you graduated so you can start customizing your own Cores!\n\nTap Close to play!",
    screen: "prism",
    action: "click",
    highlightId: "altar-close-button",
    dialogPosition: "bottom"
  },
  45: {
    id: 45,
    title: "TUTORIAL GRADUATION",
    message: "Graduation day! Enjoy 3000 EXP, 500 Hoshi, 50000 Coins, and 5 Anima Tickets.\n\nClaim your Graduation rewards in Lifetime Missions!",
    screen: "home",
    action: "any",
    dialogPosition: "bottom"
  }
};
